export default [
  {
    path: '/business/:appId/deliverables',
    name: 'DeliverableSettings',
    component: () => import('../views/business/DeliverableSettings.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    }
  },
  {
    path: '/business/:appId/customers',
    name: 'BusinessCustomers',
    component: () => import('../views/business/Customers.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    }
  },
  {
    path: '/business/:appId/ratecard',
    name: 'BusinessRatecard',
    component: () => import('../views/business/Ratecard.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    }
  },
  {
    path: '/business/:appId/customers/:customerId/deliverables',
    name: 'CustomerDeliverables',
    component: () => import('../views/business/Deliverable.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    }
  },
  {
    path: '/business/:appId/customers/:customerId/billables',
    name: 'CustomerBillables',
    component: () => import('../views/business/Billable.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    }
  },
  {
    path: '/business/:appId/customers/:customerId/statuses',
    name: 'CustomerStatuses',
    component: () => import('../views/business/Status.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    }
  },
  {
    path: '/business/:appId/customers/:customerId/acls',
    name: 'CustomerAcls',
    component: () => import('../views/business/Acl.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    }
  },
]
